const WelcomeCirclesDeco: React.FC = () => (
  <svg
    viewBox="0 0 305 111"
    className="absolute top-0 left-0 w-full h-full pointer-events-none"
    aria-hidden="true"
  >
    <circle fill="#7EBEA5" cx="102" cy="26" r="2" />
    <circle fill="#7365FF" cx="75.5" cy="8.5" r="2.5" />
    <circle fillOpacity="0.6" fill="#26295E" cx="226.5" cy="30.5" r="2.5" />
    <circle fill="#7B9DED" cx="130" cy="6" r="2" />
    <circle fill="#7365FF" cx="148" cy="18" r="2" />
    <circle fillOpacity="0.6" fill="#7B9DED" cx="15" cy="2" r="2" />
    <circle fillOpacity="0.6" fill="#7365FF" cx="2" cy="56" r="2" />
    <circle fillOpacity="0.6" fill="#7B9DED" cx="60" cy="63" r="2" />
    <circle
      fill="#8DE2B0"
      opacity="0.6"
      cx="302.033393"
      cy="33.2017242"
      r="2.1768527"
    />
    <circle fillOpacity="0.6" fill="#7365FF" cx="238" cy="54" r="2" />
    <circle fillOpacity="0.4" fill="#7365FF" cx="202" cy="4" r="2" />
    <circle fillOpacity="0.4" fill="#7365FF" cx="264" cy="13" r="2" />
    <circle fillOpacity="0.4" fill="#7EBEA5" cx="169" cy="3" r="1" />
    <circle fillOpacity="0.4" fill="#7B9DED" cx="176" cy="33" r="1" />
    <circle fill="#7B9DED" cx="107" cy="86" r="1" />
    <circle fillOpacity="0.6" fill="#26295E" cx="46" cy="92" r="5" />
    <circle fillOpacity="0.4" fill="#7EBEA5" cx="199" cy="64" r="1" />
    <circle fillOpacity="0.4" fill="#7365FF" cx="216" cy="93" r="1" />
    <circle
      fillOpacity="0.6"
      fill="#7B9DED"
      cx="231.974615"
      cy="106.400732"
      r="3.60475123"
    />
    <circle fill="#7365FF" cx="267" cy="44" r="2" />
    <circle fill="#7365FF" cx="12.5" cy="93.5" r="2.5" />
    <circle
      fillOpacity="0.6"
      fill="#7EBEA5"
      cx="272.498924"
      cy="82.1145807"
      r="2.66059774"
    />
    <circle fill="#7EBEA5" cx="29" cy="33" r="4" />
  </svg>
);

export default WelcomeCirclesDeco;
